

export const columnDefs = [


    {
        headerName: 'fk_id_categoryBtn',
        field: 'fk_id_categoryBtn',

        hide: true,
    },
    {
        headerName: 'Nom_CategoryBtn',
        field: 'Nom_CategoryBtn',

        hide: true,
    },
    {
        headerName: 'id_detail_1',
        field: 'id_detail_1',

        hide: true,
    },
    {
        checkboxSelection: true,
        headerName: '',
        field: 'Nom_Detail_1',
        filterParams: {
            defaultOption: 'startsWith',
        },

    },
    // 1ere sous catégorie
];


export const defaultColDef = {
    suppressMovable: true,
    sortable: true,
    editable: true,
    // cellEditor: 'agLargeTextCellEditor',
    maxLength: 1000,
    flex: 1,
    // filter stuff
    filter: true,
    floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
        newRowsAction: 'keep',
        // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: 'cell-wrap-text',
    autoHeight: true
};
